export default __webpack_public_path__ + "static/media/1.blur.eb065bdb.jpg";